
<mat-sidenav-container class="sidenav-container" hasBackdrop="true">
  <mat-sidenav #sidenav mode="over" position="start" fixedInViewport="true" class="sidenav">
    <app-topnav displayMode="vertical" *ngIf="sidenav.opened"></app-topnav>
  </mat-sidenav>

  <mat-sidenav-content class="sidenav-content d-flex flex-column wrapper">
    <ng-container *ngIf="internetStatus$ | async as internetStatus">
      <div *ngIf="internetStatus.online === false" class="app-alert alert alert-warning container-fluid">
        <div class="row justify-content-center">
          <span class="mr-2">No internet connection</span>
          <button mat-button mat-icon-button aria-label="Refresh" i18n-aria-label="@@refresh" class="w-auto h-auto refresh-btn" (click)="reload()">
            <i class="ms-Icon ms-Icon--Refresh" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </ng-container>
    <header *ngIf="!fullscreenView()" [ngClass]="{'sticky-header':stickyHeader}" [appStickyFill]="stickyHeader" class="d-print-none">
      <app-skip-links></app-skip-links>
      <app-topnav (toggleSideMenuEvent)="toggleSideMenu($event, sidenav)" [sideMenuIsOpen]="sidenav.opened" displayMode="horizontal"></app-topnav>
      <app-broadcasts></app-broadcasts>
    </header>
    <main class="flex-fill" id="main-content">
      <router-outlet></router-outlet>
      <router-outlet name="modal"></router-outlet>
    </main>
    <app-footer *ngIf="!fullscreenView()" class="d-print-none" id="footer"></app-footer>
  </mat-sidenav-content>
</mat-sidenav-container>


